import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/profile-indie-options*`. Composite PK (option_name, region_id);
// region defaults to 1 (EU). `pricesByElementType` is a string→decimal-string
// map (server allows any element_type key — see SKILL.md).

export interface ProfileIndieOption {
  optionName: string;
  subCategory: string | null;
  partNo: string | null;
  regionId: number;
  currency: string;
  pricesByElementType: Record<string, string | null>;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedProfileIndieOptions {
  data: ProfileIndieOption[];
  pagination: PaginationMeta;
}

export interface ListProfileIndieOptionsParams {
  page?: number;
  limit?: number;
  regionId?: number;
  search?: string;
}

export interface CreateProfileIndieOptionBody {
  optionName: string;
  subCategory?: string | null;
  partNo?: string | null;
  regionId?: number;
  currency?: string;
  pricesByElementType?: Record<string, string | number | null>;
}

export interface UpdateProfileIndieOptionBody {
  subCategory?: string | null;
  partNo?: string | null;
  regionId?: number;
  currency?: string;
  pricesByElementType?: Record<string, string | number | null>;
}

export async function listProfileIndieOptions(
  params: ListProfileIndieOptionsParams = {},
): Promise<PaginatedProfileIndieOptions> {
  const res = await Api.get("/v1/profile-indie-options", { params });
  return unwrap<PaginatedProfileIndieOptions>(res.data);
}

export async function getProfileIndieOption(
  optionName: string,
  regionId = 1,
): Promise<ProfileIndieOption> {
  const res = await Api.get(`/v1/profile-indie-options/${encodeURIComponent(optionName)}`, {
    params: { regionId },
  });
  return unwrap<ProfileIndieOption>(res.data);
}

export async function createProfileIndieOption(
  body: CreateProfileIndieOptionBody,
): Promise<ProfileIndieOption> {
  const res = await Api.post("/v1/profile-indie-options", body);
  return unwrap<ProfileIndieOption>(res.data);
}

export async function updateProfileIndieOption(
  optionName: string,
  body: UpdateProfileIndieOptionBody,
): Promise<ProfileIndieOption> {
  const res = await Api.put(`/v1/profile-indie-options/${encodeURIComponent(optionName)}`, body);
  return unwrap<ProfileIndieOption>(res.data);
}

export async function deleteProfileIndieOption(
  optionName: string,
  regionId = 1,
): Promise<void> {
  await Api.delete(`/v1/profile-indie-options/${encodeURIComponent(optionName)}`, {
    params: { regionId },
  });
}
